export default __webpack_public_path__ + "static/media/residental_loans_small.70bc0f1e.jpg";